
import { isValidPhoneNumber } from 'react-phone-number-input'

export const comparePasswords = (password, confirmPassword) => {
    if(!confirmPassword) return false
    if(password === confirmPassword) return true
}

export const validateEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
export const validatePassword = (password) => /^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,}$/.test(password)

export const validatePhoneNumber = (number, required) => {
    if (required && !number) {
        return false // If the number is required and empty, return false
    }

    if (!required && !number) {
        return true // If the number is not required and empty, return true
    }

    return isValidPhoneNumber(number) // Check if the number is valid
}

